import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
export enum InfluencerRequestError {
  CAMPAIGN_INVITATION_DELETE = 1,
  RETRIEVE_CAMPAIGN_INFO_FAIL = 2,
  CONTACT_PERMISSION_DELETE = 3,
  RETREIVE_CONTACT_PERMISSION_REQUEST_FAIL = 4,
  ACCEPT_OR_REJECT_API_FAIL = 5,
  INVITE_TOKEN_INVALID = 6,
}
@Component({
  selector: 'fail-retrieve-campaign-modal',
  templateUrl: './fail-retrieve-campaign-modal.component.html',
  styleUrls: ['./fail-retrieve-campaign-modal.component.scss']
})
export class FailRetrieveCampaignModalComponent implements OnInit {
  @Input() errorType: InfluencerRequestError;
  @Input() showTryAgainButton: boolean;
  @Output() tryAgain: EventEmitter<any> = new EventEmitter<any>();

  public modalTitle: string;
  public modalContent: string;
  public btnLabel: string;

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.btnLabel = this.translate.instant('common.btn.contact_support');
    if (this.errorType) {
      switch (this.errorType) {
        case InfluencerRequestError.CAMPAIGN_INVITATION_DELETE:
          this.modalContent = 'influencer_request.errors.invitation_deleted';
          this.modalTitle = this.translate.instant('influencer_request.error_modal.invitation_deleted_title');
          break;
        case InfluencerRequestError.RETRIEVE_CAMPAIGN_INFO_FAIL:
          this.modalContent = 'influencer_request.errors.fail_to_retrieve_campaign_info';
          this.modalTitle = this.translate.instant('influencer_request.error_modal.api_error');
          this.btnLabel = this.translate.instant('common.btn.refresh_page');
          break;
        case InfluencerRequestError.CONTACT_PERMISSION_DELETE:
          this.modalContent = 'influencer_request.errors.contact_permission_request_deleted';
          this.modalTitle = this.translate.instant('influencer_request.error_modal.contact_permission_request_deleted_title');
          break;
        case InfluencerRequestError.RETREIVE_CONTACT_PERMISSION_REQUEST_FAIL:
          this.modalContent = 'influencer_request.errors.fail_to_retrieve_contact_permission_request';
          this.modalTitle = this.translate.instant('influencer_request.error_modal.api_error');
          this.btnLabel = this.translate.instant('common.btn.refresh_page');
          break;
        case InfluencerRequestError.ACCEPT_OR_REJECT_API_FAIL:
          this.modalContent = 'all_set.error_modal.modal_content';
          this.modalTitle = this.translate.instant('all_set.error_modal.modal_title');
          this.btnLabel = this.translate.instant('all_set.error_modal.modal_btn');
          break;
        case InfluencerRequestError.INVITE_TOKEN_INVALID:
          this.modalContent = 'influencer_request.errors.invitation_deleted';
          this.modalTitle = this.translate.instant('influencer_request.error_modal.invitation_deleted_title');
          break;
        default:
          throw new Error(`Not supported the error type: ${this.errorType}`);
      }
    }
  }

  onTryAgain() {
    this.tryAgain.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component.ts